// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-list__title[data-v-742e8bec]{font-size:18px}.salon-linebreak[data-v-742e8bec]{border-color:var(--v-primary-base)}.price__from[data-v-742e8bec]{font-size:13px;font-weight:700;letter-spacing:-.5px;line-height:15px}.price__number[data-v-742e8bec]{font-size:18px;font-weight:700;letter-spacing:0;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
